// ...existing code...
import { BaseInstrument } from '../BaseInstrument';
import { AudioManager } from '../../AudioManager';
export class SamplerInstrument extends BaseInstrument {
    constructor() {
        super();
        this.sampleBuffer = null;
        this.source = null;
        this.BASE_FREQUENCY = 32.7; // Approx C1
        this.loadSample('/samples/piano/C1.mp3');
    }
    async loadSample(url) {
        const audioContext = AudioManager.getInstance().audioContext;
        try {
            const response = await fetch(url);
            const arrayBuffer = await response.arrayBuffer();
            this.sampleBuffer = await audioContext.decodeAudioData(arrayBuffer);
        }
        catch (error) {
            console.error(`Error loading sample: ${error}`);
        }
    }
    play(frequency, duration, audioContext) {
        if (!this.sampleBuffer) {
            console.warn('Sample buffer not loaded yet.');
            return;
        }
        // If we already have an indefinite source, just adjust playback rate
        if (duration <= 0 && this.source) {
            this.source.playbackRate.value = frequency / this.BASE_FREQUENCY;
            return;
        }
        // Otherwise create a new source
        this.source = audioContext.createBufferSource();
        this.source.buffer = this.sampleBuffer;
        this.source.playbackRate.value = frequency / this.BASE_FREQUENCY;
        this.source.connect(audioContext.destination);
        this.source.start();
        if (duration > 0) {
            this.source.stop(audioContext.currentTime + duration);
        }
    }
    stop(audioContext) {
        if (this.source) {
            this.source.stop();
            this.source.disconnect();
            this.source = null;
        }
    }
}
